<ion-select [class]="'language-select language-select--' + currentLanguage" interface="popover" (ionChange)="setLanguage($event)">
    <ng-container *ngFor="let availableLanguage of availableLanguages; let i = index; trackBy: languageID">
        <ion-select-option [value]="availableLanguage.value" [class]="'language-select--' + availableLanguage.value">{{ availableLanguage.label }}</ion-select-option>
    </ng-container>
</ion-select>
